import React, { FunctionComponent } from "react";

const SingleNeutralActionsBlockIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/users/geomertic-close-up-single-user-actions-neutral/single-neutral-actions-block
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M.75,17.251a6.753,6.753,0,0,1,9.4-6.208"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M3.375 4.876 A4.125 4.125 0 1 0 11.625 4.876 A4.125 4.125 0 1 0 3.375 4.876 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M11.250 17.249 A6.000 6.000 0 1 0 23.250 17.249 A6.000 6.000 0 1 0 11.250 17.249 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M13.008 21.49L21.492 13.006"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default SingleNeutralActionsBlockIcon;
